export enum ShareExpirationType {
  Never = 1,
  OneDay = 2,
  SevenDays = 3,
  ThirtyDays = 4,
  SixtyDays = 5,
  NinetyDays = 6,
  OneYear = 7,
}
